import { connect } from 'react-redux';
import styled from 'styled-components';
import { localizationSelectors } from '../../../../state/ducks/localization/selectors';
import { usersSelectors } from '../../../../state/ducks/users/selectors';
import { RootState } from '../../../../state/store/store';
import { UserDropDown } from '../../../shared/inputs/base';
import { userDetails, usersObject } from '../../../../state/ducks/users/users';

type Props = {
    updateAssignedTo: (assignedTo: string) => Promise<void>;
    localizations?: any;
    users: userDetails[];
};

const ShipmentAssignedToSelect = ({ updateAssignedTo, localizations, users }: Props) => {
    return (
        <StyledDropdownWrapper>
            <UserDropDown
                placeHolder="Assign To"
                users={users}
                customUsers
                showSearch
                value={undefined}
                onChange={async (value: string) => {
                    await updateAssignedTo(value);
                }}
                verifyChange={{
                    title: (value: string) => {
                        const user = users.find(u => u.id === value);
                        const userName = user ? `${user.firstName} ${user.lastName}` : 'Unknown User';
                        return `You are assigning the selected shipments to ${userName}. Are you sure?`
                    }
                }}
            />
        </StyledDropdownWrapper>
    );
};

const StyledDropdownWrapper = styled.div`
    & .ant-select-selector {
        background-color: white !important;
        border-color: rgba(255, 255, 255, 0.5) !important;
    }
    
    & .ant-select-selection-item {
        color: #333 !important;
    }
    
    & .ant-select-focused .ant-select-selector {
        border-color: white !important;
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2) !important;
    }
    
    & .ant-select-arrow {
        color: rgba(255, 255, 255, 0.8) !important;
    }
    
    & .ant-select-selection-placeholder {
        color: rgba(0, 0, 0, 0.5) !important;
    }
    
    & .ant-select-dropdown {
        background: white !important;
        border: 1px solid #d9d9d9;
        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
    }
    
    & .ant-select-item {
        background: white !important;
        color: #333 !important;
    }
    
    & .ant-select-item:hover {
        background: #f5f5f5 !important;
    }
    
    & .ant-select-item-option-selected {
        background: #e6f7ff !important;
        color: #1890ff !important;
    }
`;

const mapStateToProps = (state: RootState) => ({
    localizations: localizationSelectors.singleShipmentPage(state),
    users: Object.values(usersSelectors.users(state) || {}) as userDetails[]
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentAssignedToSelect);
